import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

export const StyledMedicinalProductLabel = styled.div`
  display: flex;
  align-items: flex-start;
  padding-right: 0.25rem;
  margin-top: 0.25rem;
  color: ${theme.color.text.negative};
`;
